export const profile = {
communicationPrefs: {
screenTitle: "تفضيلات التواصل",
screenSubtitle: "اختر ما نتواصل معك بشأنه. الإشعارات المطلوبة ضرورية لكي تعمل الخدمة بأمان؛ أما الاختيارية فالقرار فيها لك بالكامل.",
requiredSectionTitle: "مطلوب",
requiredSectionHint: "تُرسل عبر البريد الإلكتروني و/أو الإشعارات الفورية. مطلوبة لاستخدام AssetWRX بأمان.",
requiredBadge: "مطلوب",
optionalSectionTitle: "اختياري",
optionalSectionHintLoading: "جارٍ تحميل تفضيلاتك...",
optionalSectionHint: "قم بالتبديل بين التشغيل أو الإيقاف في أي وقت. يسري مفعول السحب على الفور ويتم تسجيله في سجل موافقتك.",
alwaysOnBadge: "قيد التشغيل دائمًا",
alwaysOnHintLegit: "مفعّل دائمًا (ضروري لتشغيل الخدمة بأمان)",
marketingEmailTitle: "تحديثات المنتج والنصائح والعروض الترويجية - البريد الإلكتروني",
marketingEmailBody: "رسائل بريد إلكتروني من حين لآخر حول الميزات الجديدة وأنماط سير العمل والعروض. إيقاف بشكل افتراضي.",
marketingPushTitle: "تحديثات المنتج والنصائح والعروض الترويجية - الإشعارات الفورية",
marketingPushBody: "إشعارات فورية للإطلاقات والعروض الرئيسية. متوقفة افتراضيًا.",
analyticsTitle: "تحليلات المنتج",
analyticsBody: "ساعدنا على فهم كيفية استخدام AssetWRX لنتمكن من تحسينه: الشاشات المستخدمة والنقرات وتسجيلات الجلسات مع إخفاء كل ما تكتبه.",
crashReportingTitle: "الإبلاغ عن الأعطال والاستقرار",
crashReportingBody: "تقارير أعطال خالية من بياناتك الشخصية. مفعّلة دائمًا لأننا نحتاجها لإبقاء AssetWRX يعمل.",
serviceNotifTitle: "إشعارات الخدمة",
serviceNotifBody: "تنبيهات الحوادث وإيصالات الفواتير وتغييرات الحساب.",
securityNotifTitle: "إخطارات الأمان",
securityNotifBody: "تنبيهات تسجيل الدخول، وتغييرات كلمة المرور، وتحذيرات الأنشطة المشبوهة.",
inspectionRemindersTitle: "تذكيرات الفحص",
inspectionRemindersBody: "تذكيرات لعمليات التفتيش المجدولة التي تمتلكها.",
confirmEmailError: "تعذر إرسال رسالة تأكيد بالبريد الإلكتروني. حاول ثانية.",
alreadySubscribed: "أنت مشترك بالفعل.",
confirmationSent: "تحقق من بريدك الإلكتروني — لقد أرسلنا رابط تأكيد. اضغط عليه خلال 24 ساعة للاشتراك.",
updatedFeedback: "تم تحديث {{title}}.",
saveError: "تعذر حفظ تفضيلاتك. حاول ثانية.",
pendingHint: "معلّق — تحقق من بريدك الإلكتروني للحصول على رابط التأكيد (صالح لمدة 24 ساعة).",
deliveryPausedHint: "أُوقف الاشتراك مؤقتًا بسبب مشكلات في التسليم. أوقِفه ثم شغّله لإعادة المحاولة.",
},
consentHistory: {
loading: "جارٍ التحميل…",
errorTitle: "خطأ",
emptyTitle: "لا توجد أحداث موافقة حتى الآن",
emptyBody: "بمجرد قبول أي تفضيل أو تغييره، سيظهر هنا.",
screenTitle: "سجل الموافقات",
screenSubtitle: "كل سياسة قبلتها وكل خيار تسويقي أو تحليلي منحته أو سحبته. تُحفظ الإدخالات كما هي ولا يمكن تغييرها. إعدادات تنبيهات الهاتف ليست موافقات وتوجد في التفضيلات.",
labelTerms: "شروط الخدمة",
labelPrivacy: "سياسة الخصوصية",
labelMarketingEmail: "البريد الإلكتروني التسويقي",
labelMarketingPush: "الإشعارات التسويقية",
labelAnalytics: "تحليلات المنتج",
labelCrashReporting: "تقارير الأعطال",
labelCookieAnalytics: "ملفات تعريف الارتباط التحليلية",
labelCookieMarketing: "ملفات تعريف الارتباط التسويقية",
labelLocationSharing: "مشاركة الموقع أثناء العمل",
actionAccepted: "تم القبول",
actionWithdrawn: "تم السحب",
actionUpdated: "محدّثة",
detailSource: "مُنحت عبر",
detailReason: "السبب",
sourcePhonePrompt: "سؤال التحليلات في التطبيق",
sourceSignup: "التسجيل",
sourceCookieBanner: "شريط ملفات تعريف الارتباط",
sourceSignupCatchup: "التسجيل (سُجّل لاحقًا)",
device: {
ios: "iPhone أو iPad",
android: "جهاز Android",
web: "متصفح الويب",
unknown: "جهاز غير معروف",
},
},
exportData: {
whatYoullReceiveTitle: "ما ستحصل عليه",
itemProfile: "ملفك الشخصي وإعدادات الحساب",
itemAssets: "جميع الأصول وعمليات التفتيش وأوامر العمل التي تمتلكها",
itemContacts: "جهات الاتصال وعضويات الفريق",
itemRequests: "الطلبات التي قدّمتها وكل الرسائل المتعلقة بها",
itemReports: "التقارير وعروض الأسعار التي تمت مشاركتها معك، مع ردودك",
itemConsent: "سجل موافقاتك وسجل التدقيق كاملين",
itemDeletionLog: "إدخالات سجل حذف الحساب (إن وجدت)",
itemPriorExports: "نسخة من أي طلبات تصدير سابقة",
footnote: "يعمل كل رابط تنزيل لمدة 7 أيام ولك وحدك.",
preparing: "جارٍ إعداد عملية التصدير...",
requestButton: "اطلب تصدير بياناتي",
recentRequestsTitle: "الطلبات الأخيرة",
loading: "جارٍ التحميل…",
noExportsYet: "لا توجد عمليات تصدير حتى الآن — اطلب واحدة أعلاه للبدء.",
statusQueued: "في قائمة الانتظار",
statusProcessing: "قيد المعالجة",
statusReady: "جاهز",
statusFailed: "فشل",
statusExpired: "منتهي الصلاحية",
requestedAt: "طُلب في {{date}}",
linkExpires: "ينتهي الرابط في {{date}}",
linkExpiresSoon: "تنتهي الصلاحية خلال 24 ساعة · ينتهي الرابط في {{date}}",
downloadButton: "تنزيل",
readyFeedback: "تصديرك جاهز. اضغط على \"تنزيل\" أدناه لحفظه.",
screenTitle: "تصدير بياناتي",
screenSubtitle: "يمكنك تنزيل نسخة من بيانات حسابك في AssetWRX في أي وقت. تصلك كملف بيانات يمكن لبرامج أخرى فتحه.",
},
privacyDataHub: {
screenTitle: "الخصوصية والبيانات",
screenSubtitle: "نزّل بياناتك، أو اختر ما نرسله إليك بالبريد، أو احذف حسابك. يُسجَّل كل تغيير في سجل موافقاتك.",
expandLabel: "فتح",
collapseLabel: "إغلاق",
itemPrivacyTitle: "سياسة الخصوصية",
itemPrivacyBody: "كيف نقوم بجمع بياناتك واستخدامها وحمايتها.",
itemTermsTitle: "شروط الخدمة",
itemTermsBody: "الاتفاقية التي تحكم استخدامك لـ AssetWRX.",
itemCookiesTitle: "سياسة ملفات تعريف الارتباط",
itemCookiesBody: "ما هي ملفات تعريف الارتباط ووحدات التخزين المشابهة التي نستخدمها وكيفية التحكم فيها.",
itemSubprocessorsTitle: "المعالِجون الفرعيون",
itemSubprocessorsBody: "الأطراف الخارجية التي نستعين بها لمعالجة البيانات، ومواقع عملها.",
itemDpaTitle: "اتفاقية معالجة البيانات",
itemDpaBody: "كيف نتعامل مع محتواك نيابة عنك.",
itemMarketingTitle: "سياسة الموافقة على التسويق",
itemMarketingBody: "كيف نحصل على اشتراكك ونثبته ونحترمه.",
itemExportTitle: "تصدير بياناتي",
itemExportBody: "نزّل نسخة من كل ما في حسابك.",
itemCommsTitle: "تفضيلات التواصل",
itemCommsBody: "اختر التحديثات والنصائح الاختيارية التي تتلقاها وعلى أي القنوات.",
itemHistoryTitle: "سجل الموافقات",
itemHistoryBody: "كل سياسة قبلتها وكل موافقة تسويقية أو تحليلية منحتَها أو سحبتَها.",
itemAiTitle: "ميزات الذكاء الاصطناعي",
itemAiBody: "ما إذا كان يجوز لـ AssetWRX إرسال الصور والنصوص إلى Google (Gemini) عند استخدامك ميزة ذكاء اصطناعي على هذا الجهاز.",
aiAllowed: "مسموح على هذا الجهاز. تعالج Google ما ترسله ميزة الذكاء الاصطناعي ولا تستخدمه لتدريب نماذجها.",
aiNotAllowed: "غير مسموح. تسأل ميزات الذكاء الاصطناعي قبل إرسال أي شيء.",
aiWithdraw: "إيقاف استخدام الذكاء الاصطناعي على هذا الجهاز",
aiAllow: "السماح بميزات الذكاء الاصطناعي",
itemDeletionPolicyTitle: "سياسة حذف البيانات",
itemDeletionPolicyBody: "كيف يعمل الحذف، وما يتم الاحتفاظ به، ونافذة الاسترداد لمدة 30 يومًا.",
itemDeleteTitle: "حذف الحساب",
itemDeleteBody: "حذف حسابك وبياناتك بشكل لا رجعة فيه. تنطبق نافذة الاسترداد لمدة 30 يوما.",
},
security: {
  twoFactorSection: "تسجيل الدخول بخطوتين",
  signIn: {
    cancel: "إلغاء",
    biometricOffHint: "متوقف. يتم نسيان بيانات الدخول المحفوظة على هذا الهاتف.",
    biometricOnHint: "مفعّل. يسجّل {{method}} دخولك على هذا الهاتف (بعد تسجيل الدخول مرة واحدة بكلمة المرور).",
    biometricTitle: "تسجيل الدخول باستخدام {{method}} على هذا الهاتف",
    setPasswordFailed: "لم يُرسل الرابط. تحقّق من اتصالك وحاول مرة أخرى.",
    setPasswordSent: "أرسلنا رابطًا إلى {{email}}. افتحه لتعيين كلمة المرور. لا يزال بإمكانك تسجيل الدخول عبر Google أو Apple أو Microsoft.",
    passwordChanged: "تم تغيير كلمة المرور. استخدمها في المرة القادمة التي تسجّل فيها الدخول.",
    passwordFailed: "لم تتغيّر كلمة المرور. حاول مرة أخرى.",
    passwordMismatch: "كلمتا المرور مختلفتان. اكتب الكلمة نفسها مرتين.",
    passwordRequired: "أدخل كلمة مرور جديدة.",
    passwordSave: "حفظ كلمة المرور",
    passwordConfirmLabel: "اكتبها مرة أخرى",
    passwordNewLabel: "كلمة المرور الجديدة",
    setPassword: "تعيين كلمة مرور",
    passwordChange: "تغيير كلمة المرور",
    passwordNone: "تسجّل الدخول عبر Google أو Apple أو Microsoft، لذا لا توجد كلمة مرور بعد.",
    passwordSet: "تسجّل الدخول بكلمة مرور.",
    passwordTitle: "كلمة المرور",
    emailSent: "أرسلنا رابطًا إلى عنوانك الجديد {{email}}. افتحه لإتمام التغيير. حتى ذلك الحين تواصل تسجيل الدخول باستخدام {{current}}.",
    emailFailed: "لم يُرسل الرابط. تحقّق من اتصالك وحاول مرة أخرى.",
    emailTaken: "هناك حساب آخر يستخدم هذا العنوان. استخدم عنوانًا مختلفًا.",
    emailSame: "هذا هو عنوان بريدك بالفعل.",
    emailInvalid: "أدخل عنوان بريد مثل name@company.com.",
    emailSend: "إرسال الرابط",
    emailNewHelper: "نرسل رابطًا إلى العنوان الجديد. يتم التغيير عند فتحه.",
    emailNewLabel: "عنوان البريد الجديد",
    emailPending: "بانتظار فتحك للرابط المرسل إلى {{email}}.",
    emailChange: "تغيير البريد",
    emailTitle: "البريد الإلكتروني",
    sectionTitle: "طريقة تسجيل دخولك",
  },
title: "الأمن",
removeLastWarning: "هذه أداة المصادقة الوحيدة لديك. تسجيل الدخول بخطوتين إلزامي، لذا سيُطلب منك إعداد أداة أخرى فورًا.",
removeBody: "هل تريد إزالة هذا الموثق؟ ويمكنك إضافته مرة أخرى لاحقًا.",
removeTitle: "إزالة أداة المصادقة",
cancel: "إلغاء",
remove: "إزالة",
removeFailedTitle: "تعذّرت الإزالة",
removeFailedBody: "حاول مرة أخرى.",
statusOn: "تسجيل الدخول الثنائي قيد التشغيل",
statusOff: "تم إيقاف تسجيل الدخول الثنائي",
statusSub: "يحمي حسابك برمز من تطبيق المصادقة (Microsoft\u{00A0}Authenticator، Google\u{00A0}Authenticator، Authy).",
methods: "أدوات المصادقة الخاصة بك",
loading: "جارٍ التحميل…",
none: "لم تُعدّ أي أداة مصادقة بعد.",
authenticator: "أداة المصادقة",
added: "مُضافة",
removeA11y: "إزالة أداة المصادقة",
add: "إضافة أداة مصادقة",
addBackup: "إضافة أداة مصادقة احتياطية",
},
diagnosticsScreen: {
  title: "التشخيص",
  subtitle: "ما يحتاج الدعم إلى معرفته. لا شيء هنا سري.",
  sectionBuild: "البناء",
  sectionWorkspace: "مساحة العمل",
  sectionConnectivity: "الاتصال",
  sectionServices: "الخدمات",
  appVersion: "إصدار التطبيق",
  build: "رقم البناء",
  commit: "التزام Git",
  runtime: "إصدار وقت التشغيل",
  updateChannel: "قناة التحديث",
  platform: "المنصة",
  environment: "البيئة",
  backend: "الخادم الخلفي",
  workspace: "مساحة العمل",
  role: "الدور",
  plan: "الخطة",
  capabilities: "الميزات المفعّلة",
  connectivity: "الاتصال",
  online: "متصل",
  offline: "غير متصل",
  outbox: "تغييرات بانتظار الإرسال",
  lastSync: "آخر إرسال",
  sentry: "تقارير الأعطال",
  sentryOn: "مفعّل · الإصدار {{release}}",
  sentryOff: "غير مهيأ",
  posthog: "تحليلات المنتج",
  posthogOn: "مفعّلة (تمت الموافقة)",
  posthogOff: "معطّلة (بدون موافقة)",
  apiHealth: "حالة واجهة API",
  apiChecking: "جارٍ التحقق…",
  apiOk: "سليم · {{latency}} مللي ثانية · الترحيلات {{head}}",
  apiFail: "غير قابل للوصول",
  push: "الإشعارات الفورية",
  pushRegistered: "مسجّل لدى خدمة Expo للإشعارات",
  pushNotRegistered: "غير مسجّل على هذا الجهاز (يتطلب إصدارًا يحتوي على بيانات اعتماد الإشعارات وإذنًا ممنوحًا)",
  pushUnsupported: "غير متاح على هذه المنصة",
  copy: "نسخ التشخيص",
  copied: "تم النسخ",
  never: "أبدًا",
  unknown: "غير معروف",
  personal: "شخصي",
  none: "لا شيء",
  web: "الويب",
},
whatsNew: {
  eyebrow: "ما الجديد في AssetWRX",
  gotIt: "حسنًا",
  seeAll: "عرض كل التحديثات",
  sectionTitle: "ما الجديد",
  empty: "لا توجد ملاحظات إصدار بعد.",
  dateLine: "{{date}} · الإصدار {{version}}",
},
aboutScreen: {
  product: "AssetWRX {{version}}",
  title: "حول",
  subtitle: "إصدار AssetWRX على هذا الجهاز. انسخه عند التواصل مع الدعم.",
  build: "البناء {{build}}",
  webBuild: "الويب",
  runtime: "وقت التشغيل {{runtime}}",
  channel: "القناة {{channel}}",
  environment: "البيئة {{environment}}",
  update: "التحديث {{update}}",
  copy: "نسخ",
  copied: "تم النسخ",
},
helpScreen: {
  contactSupportSubtitle: "اسأل شخصًا. يفتح صفحة الدعم في متصفحك.",
  contactSupportTitle: "تواصل مع دعم AssetWRX",
subtitle: "يساعدك AssetWRX على إدارة الأصول وإجراء الفحوصات وتتبع مهام الإصلاح.",
coreWorkflowTitle: "سير العمل الأساسي",
coreWorkflowBody: "• إضافة الأصول (المركبات والمعدات والممتلكات)\n• بدء عملية فحص باستخدام قائمة مرجعية\n• مشاركة التقرير للحصول على موافقة العميل\n• تحويل الإصلاحات المعتمدة إلى أوامر عمل\n• تعيين أوامر العمل لأعضاء الفريق أو المقاولين",
toursTitle: "جولات إرشادية",
toursSubtitle: "شروحات خطوة بخطوة داخل التطبيق: تسجيل أصل، إجراء فحص، إعداد الصيانة.",
openToursA11y: "فتح الجولات الإرشادية",
guideTitle: "دليل المستخدم",
guideSubtitle: "أدلة خطوة بخطوة لكل جزء من AssetWRX.",
openGuideA11y: "افتح دليل المستخدم",
},
pushNotificationPrefs: {
  productTitle: "أخبار المنتج",
  productBody: "الردود على طلبات الميزات منك وأخبار الأفكار التي صوّتّ لها.",
  saveFailed: "لم يُحفظ هذا الإعداد. تحقّق من اتصالك وحاول مرة أخرى.",
  permission: {
    onBody: "اختر أدناه التنبيهات التي تصلك.",
    onTitle: "الإشعارات مفعّلة على هذا الهاتف",
    openSettings: "فتح الإعدادات",
    blockedBody: "هذا الهاتف لا يسمح لتطبيق AssetWRX بإرسال التنبيهات. فعّلها من إعدادات الهاتف، ثم عُد.",
    blockedTitle: "الإشعارات متوقفة لتطبيق AssetWRX",
    askAction: "تشغيل الإشعارات",
    askBody: "نُعلمك عندما يُسند إليك عمل، أو يردّ أحدهم، أو ينتظر أمر ما قرارك. سيطلب هاتفك منك السماح بذلك.",
    askTitle: "تلقَّ التنبيهات على هذا الهاتف",
  },
assignmentTitle: "المُسنَد إليّ",
assignmentBody: "أوامر العمل والفحوصات المُسندة إليك، ودعوات المقاولين، والعمل الممنوح.",
messageTitle: "الرسائل",
messageBody: "الردود على أوامر العمل، والتقارير المشتركة معك، وتقارير Asset 360 وSite 360 عندما تكون جاهزة.",
approvalTitle: "الموافقات والطلبات",
approvalBody: "الطلبات الجديدة، وعروض الأسعار المقدَّمة، والإكمالات، وطلبات الوصول إلى التقارير التي تنتظر قرارك.",
cardTitle: "الإشعارات الفورية",
hintUnsupported: "تُرسل الإشعارات الفورية إلى تطبيق AssetWRX على الهاتف المحمول. تنطبق هذه الإعدادات على هاتفك.",
hintLoading: "جارٍ تحميل إعداداتك...",
hintDefault: "اختر ما يصل إلى هاتفك. سيظل كل شيء يظهر في البريد الوارد داخل التطبيق في كلتا الحالتين.",
saveError: "تعذّر الحفظ: {{error}}",
quietHoursTitle: "ساعات هادئة",
quietHoursBody: "لا تُرسل إشعارات فورية خلال هذه الفترة. تظل الإشعارات تصل إلى البريد الوارد داخل التطبيق{{suffix}}.",
fromLabel: "من",
toLabel: "إلى",
androidChannelNote: "كل فئة لها قناة إشعارات Android خاصة بها، لذا يمكنك أيضًا ضبط الصوت والأولوية لكل فئة في إعدادات النظام.",
},
personal: {
notSet: "غير محدد",
personalMode: "الوضع الشخصي",
roleInCurrentContext: "الدور في السياق الحالي",
roleUnavailable: "الدور غير متاح",
languageNotSet: "غير محدد (افتراضي مساحة العمل، ثم الجهاز)",
timezoneNotSet: "غير محدد (افتراضي مساحة العمل، ثم الجهاز)",
languageHelper: "اتركه فارغًا لاستخدام افتراضي مساحة العمل، ثم لغة الجهاز إن كانت مدعومة، ثم الإنجليزية (الولايات المتحدة).",
timezoneHelper: "اتركه فارغًا لاستخدام المنطقة الزمنية لمساحة العمل، ثم جهازك، ثم UTC.",
effectiveLanguage: "اللغة الفعلية",
effectiveTimezone: "المنطقة الزمنية الفعلية",
localeMoved: "اللغة والمنطقة الزمنية موجودتان في التفضيلات",
localeMovedA11y: "افتح التفضيلات لتغيير اللغة والمنطقة الزمنية",
sectionTitle: "البيانات الشخصية",
sectionSubtitle: "الاسم وبيانات التواصل والنبذة.",
photoTitle: "صورة الملف الشخصي",
photoSubtitle: "تظهر صورتك في الواجهة الرئيسية وعروض الفريق والنشاط. وهي مستقلة عن شعارات مساحة العمل أو التقارير.",
edit: "تعديل",
fullName: "الاسم الكامل",
displayName: "اسم العرض",
phone: "الهاتف",
language: "اللغة",
timezone: "المنطقة الزمنية",
email: "البريد الإلكتروني",
bio: "نبذة",
shortBio: "نبذة قصيرة",
editTitle: "تعديل الملف الشخصي",
fieldDisplayName: "اسم العرض",
placeholderDisplayName: "كيف تريد ظهور اسمك",
fieldFirstName: "الاسم الأول",
placeholderFirstName: "الاسم الأول",
fieldLastName: "اسم العائلة",
placeholderLastName: "اسم العائلة",
fieldJobTitle: "المسمى الوظيفي",
placeholderJobTitle: "المسمى الوظيفي",
langA11y: "اللغة",
tzA11y: "المنطقة الزمنية",
bioPlaceholder: "وصف قصير لملفك الشخصي",
emailReadOnlyHint: "لتغيير بريدك الإلكتروني، انتقل إلى الحساب ← الأمان.",
cancel: "إلغاء",
saveProfile: "حفظ الملف الشخصي",
pickerLanguageTitle: "اللغة",
pickerTimezoneTitle: "المنطقة الزمنية",
searchLanguage: "ابحث عن لغة أو رمز",
searchTimezone: "ابحث عن منطقة زمنية",
errorInvalidPhone: "أدخل رقم هاتف صالحًا.",
saveSuccessTitle: "تم الحفظ",
saveSuccessBody: "تم تحديث ملفك الشخصي.",
saveErrorGeneric: "تعذّر حفظ الملف الشخصي.",
phoneNumberLabel: "رقم الهاتف",
countryCallingCodeA11y: "رمز الاتصال بالدولة",
countryCallingCodeHint: "يفتح قائمة الدول",
nationalNumberPlaceholder: "الرقم الوطني",
nationalNumberA11y: "الرقم الوطني للهاتف",
countryRegionTitle: "الدولة أو المنطقة",
searchCountry: "ابحث عن دولة أو رمز",
},
overview: {
  tileIndustryPacksSubtitle: "أنواع أصول وقوائم تحقق وخطط جاهزة",
  tileIndustryPacksTitle: "حزم القطاعات",
  tileAssetTypesTitle: "أنواع الأصول",
  tileAssetTypesSubtitle: "أنواع الأصول والأماكن الخاصة بك والتفاصيل التي يطلبها كل منها",
changePhoto: "تغيير الصورة",
uploadPhoto: "رفع صورة",
remove: "إزالة",
noJobTitle: "لا يوجد مسمى وظيفي بعد",
profileCompleteness: "اكتمال الملف الشخصي",
memberSince: "عضو منذ",
recentMember: "انضم مؤخرًا",
moreSection: "المزيد",
moreSubtitle: "مساحة العمل وتفضيلاتك والجلسة.",
personalSection: "شخصي",
workspaceSection: "مساحة العمل",
sessionSection: "الجلسة",
workspace: "مساحة العمل",
workspaceSubtitle: "السياق والقيم الافتراضية وهوية التقرير.",
preferences: "التفضيلات",
help: "المساعدة",
securitySection: "الأمان والخصوصية",
privacyData: "الخصوصية والبيانات",
consentHistory: "سجل الموافقات",
exportData: "تصدير بياناتي",
deleteAccount: "حذف الحساب",
signOut: "تسجيل الخروج",
signOutTitle: "تسجيل الخروج",
signOutConfirm: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
signOutCancel: "إلغاء",
signOutAction: "تسجيل الخروج",
signOutPendingNote: "يبقى عملك المعلَّق على هذا الجهاز عند تسجيل الخروج. يمكنك مراجعة المزامنة وحل أي أخطاء قبل المغادرة.",
reviewPendingWrites: "مراجعة التغييرات التي تنتظر المزامنة",
signOutErrorTitle: "تعذر إنهاء تسجيل الخروج",
signOutErrorBody: "تم الاحتفاظ بتغييراتك المحفوظة. يرجى المحاولة مرة أخرى.",
workspaceTypeMember: "عضو",
workspaceTypeContractor: "متعهد",
workspaceTypeRecipient: "مستلم",
teamsCount_one: "{{count}} فريق",
teamsCount_other: "{{count}} فريق",
kpiUsersLabel: "المستخدمون",
kpiUsersHint: "في مساحة العمل هذه",
kpiAssetsLabel: "الأصول",
kpiAssetsHint: "إجمالي مساحة العمل",
kpiInspectionsLabel: "التفتيش",
kpiInspectionsHint: "كافة السجلات",
kpiJobsLabel: "المهام",
kpiJobsOpenHint_zero: "{{count}} مفتوح",
kpiJobsOpenHint_one: "{{count}} مفتوح",
kpiJobsOpenHint_two: "{{count}} مفتوح",
kpiJobsOpenHint_few: "{{count}} مفتوح",
kpiJobsOpenHint_many: "{{count}} مفتوح",
kpiJobsOpenHint_other: "{{count}} مفتوح",
kpiCreditsLabel: "أرصدة الذكاء الاصطناعي",
kpiCreditsHint: "الرصيد المتاح",
creditsUnlimited: "غير محدود",
groupSettingsA11y_zero: "{{title}}، {{count}} إعداد. {{action}}.",
groupSettingsA11y_one: "{{title}}، إعداد واحد. {{action}}.",
groupSettingsA11y_two: "{{title}}، إعدادان. {{action}}.",
groupSettingsA11y_few: "{{title}}، {{count}} إعدادات. {{action}}.",
groupSettingsA11y_many: "{{title}}، {{count}} إعدادًا. {{action}}.",
groupSettingsA11y_other: "{{title}}، {{count}} إعداد. {{action}}.",
groupExpandAction: "قم بالتوسيع",
groupCollapseAction: "طي",
groupYouTitle: "أنت",
groupPlanTitle: "الخطة والأدوات",
tileOrganizationTitle: "المؤسسة",
tileOrganizationSubtitleAdmin: "شعار مساحة العمل والملف التعريفي للشركة والتفاصيل القانونية",
tileOrganizationSubtitleMember: "عرض شعار مساحة العمل والملف التعريفي للشركة والتفاصيل القانونية",
tileTeamsTitle: "الفرق والدعوات",
tileTeamsSubtitleAdmin: "أعضاء مساحة العمل والأدوار والدعوات",
tileTeamsSubtitleMember: "عرض أعضاء مساحة العمل والأدوار ودعواتك",
tileDefaultsTitle: "الإعدادات الإقليمية الافتراضية",
tileDefaultsSubtitle: "العملة واللغة والمنطقة الزمنية وطرق المشاركة",
tileBrandingTitle: "هوية التقارير",
tileBrandingSubtitleAdmin: "PDF/شعار المشاركة وتفاصيل التصدير (منفصلة عن مساحة العمل)",
tileBrandingSubtitleMember: "عرض شعار PDF/المشاركة وتفاصيل التصدير",
tileIntegrationsTitle: "التكاملات",
tileIntegrationsSubtitle: "اربط أنظمة أخرى وأدخِل البيانات",
tileTemplatesTitle: "قوائم التحقق",
tileTemplatesSubtitle: "مخططات التفتيش وأمر العمل",
tileAiTitle: "الذكاء الاصطناعي",
tileAiSubtitle: "الاستخدام والأتمتة والتدقيق",
tileAssistantActivityTitle: "نشاط المساعد",
tileAssistantActivitySubtitle: "التغييرات التي تمت عبر المساعد",
tileYourPlanTitle: "خطة {{plan}}",
tileYourPlanTitleLimit_zero: "خطة {{plan}} · {{owned}} من {{count}} أصل",
tileYourPlanTitleLimit_one: "خطة {{plan}} · {{owned}} من أصل واحد",
tileYourPlanTitleLimit_two: "خطة {{plan}} · {{owned}} من أصلين",
tileYourPlanTitleLimit_few: "خطة {{plan}} · {{owned}} من {{count}} أصول",
tileYourPlanTitleLimit_many: "خطة {{plan}} · {{owned}} من {{count}} أصلًا",
tileYourPlanTitleLimit_other: "خطة {{plan}} · {{owned}} من {{count}} أصل",
tileYourPlanTitleUnknown: "خطتك",
tileYourPlanSubtitle: "اطّلع على الخطط وما تتضمنه كل منها",
tileBillingTitle: "الفوترة",
tileBillingSubtitleAdmin: "الخطة والأرصدة والفواتير",
tileBillingSubtitleMember: "عرض الخطة واستخدام الرصيد",
tileGuideTitle: "دليل المستخدم",
tileGuideSubtitle: "أدلة خطوة بخطوة لكل جزء من AssetWRX",
tileProfileTitle: "الملف الشخصي",
tileProfileSubtitle: "الاسم، الصورة، جهة الاتصال",
tilePreferencesSubtitle: "اللغة والمظهر وتنبيهات الهاتف",
tileSecurityTitle: "الأمن",
tileSecuritySubtitle: "البريد وكلمة المرور والتحقق بخطوتين",
tilePrivacyTitle: "الخصوصية",
tilePrivacySubtitle: "بياناتك، رسائلنا، حذف الحساب",
tileFeaturesTitle: "الميزات",
tileFeaturesSubtitle: "ما هو مفعّل أو معطّل أو مقفل في مساحة العمل هذه",
tileDiagnosticsTitle: "التشخيص",
tileDiagnosticsSubtitle: "حالة الإصدار والاتصال والمزامنة للدعم",
tileAboutTitle: "حول",
tileAboutSubtitle: "الإصدار ورقم البناء",
groupAppTitle: "التطبيق",
tileHelpTitle: "المساعدة",
groupAdvancedTitle: "متقدم",
tileNotificationsTitle: "الإشعارات",
tileNotificationsSubtitle: "رسائل البريد والتنبيهات التي تصلك",
tileBrandingDefaultsTitle: "الهوية والافتراضيات",
tileBrandingDefaultsSubtitle: "المؤسسة وهوية التقارير والافتراضيات الإقليمية",
tileApiExplorerTitle: "مستكشف API",
tileApiExplorerSubtitle: "جرّب واجهة API العامة بمفاتيحك",
tileHandbookTitle: "دليل التكامل",
tileHandbookSubtitle: "أدلة لربط AssetWRX وأتمتته",
tileHelpSubtitle: "كيف يعمل AssetWRX وأين يمكن الحصول على الدعم",
teamsCount_zero: "لا فرق",
teamsCount_two: "فريقان",
teamsCount_few: "{{count}} فرق",
teamsCount_many: "{{count}} فريقًا",
},
tabs: {
summary: "ملخص",
personal: "شخصي",
profilePagesA11y: "صفحات الإعدادات الشخصية",
},
accountScreen: {
title: "إعدادات الحساب",
subtitleOverview: "أدِر ملفك الشخصي ومساحة العمل والفوترة والتكاملات.",
subtitleOverviewPersonalOnly: "ملفك الشخصي وتفضيلاتك والأمان والخصوصية.",
subtitlePersonal: "اسمك وبيانات التواصل وصورتك",
subtitleWorkspace: "ملف مساحة العمل والفريق والتكاملات والفوترة",
},
accountScope: {
areasA11y: "مناطق إعدادات الحساب",
userDetails: "شخصي",
userDetailsHint: "ملفك التعريفي وتفضيلاتك والمساعدة",
userDetailsTabA11y: "الإعدادات الشخصية",
workspace: "مساحة العمل",
workspaceHint: "المؤسسة والفريق والإدارة",
workspaceTabA11y: "إعدادات مساحة العمل",
},
preferences: {
title: "التفضيلات",
subtitle: "الإعدادات التي تنطبق عليك فقط.",
localeTitle: "اللغة والمنطقة",
localeHint: "كيفية عرض التواريخ والأوقات والنصوص لك. تتبع هذه الإعدادات حسابك، لذا تنطبق على كل جهاز تسجّل الدخول منه.",
localeLanguage: "اللغة",
localeTimezone: "المنطقة الزمنية",
localeLanguageA11y: "تغيير اللغة",
localeTimezoneA11y: "تغيير المنطقة الزمنية",
localeEffectiveLanguage: "المستخدَمة حاليًا: {{value}}",
localeEffectiveTimezone: "المستخدَمة حاليًا: {{value}}",
localeSaveError: "تعذّر حفظ اللغة والمنطقة الزمنية.",
notificationsTitle: "الإشعارات",
pushNotifications: "الإشعارات الفورية",
pushNotificationsHint: "فعّل التنبيهات والتحديثات لمراجعات التفتيش وأوامر العمل والتذكيرات.",
haptics: "الاهتزاز عند اللمس",
hapticsHint: "نقرة خفيفة في يدك عند إكمال شيء أو حفظه أو تحديده.",
appearanceTitle: "المظهر",
appearanceHint: "يحدد استخدام الشاشات لسطوح فاتحة أو داكنة على هذا الجهاز. مطابقة النظام تتبع إعداد هاتفك أو حاسوبك.",
appearanceLight: "فاتح",
appearanceDark: "داكن",
appearanceSystem: "مطابقة النظام",
densityComfy: "مريح",
densityComfyHint: "مساحة أكبر بين العناصر",
densityCompact: "مضغوط",
densityCompactHint: "متوازن",
densityDense: "كثيف",
densityDenseHint: "أكبر قدر على الشاشة",
textSizeDefault: "الافتراضي",
textSizeLarge: "كبير",
textSizeExtraLarge: "كبير جدًا",
privacyTitle: "الخصوصية والبيانات",
privacyHint: "إدارة بياناتك الشخصية وحسابك.",
privacyOpenA11y: "فتح الخصوصية والبيانات",
deleteAccount: "حذف الحساب",
deleteAccountHint: "احذف حسابك وبياناتك الشخصية نهائيًا.",
textSizeTitle: "حجم النص",
textSizeHint: "اجعل النص في جميع أنحاء التطبيق أسهل في القراءة. ينطبق هذا في كل مكان ويعمل جنبًا إلى جنب مع إعداد حجم النص الخاص بجهازك.",
textSizeA11y: "حجم النص {{label}}",
densityTitle: "كثافة العرض",
densityHint: "مقدار المعلومات الموجودة على كل شاشة. ينطبق في كل مكان.",
densityA11y: "كثافة العرض {{label}}",
privacyDataTitle: "الخصوصية والبيانات",
privacyDataHint: "سياسة الخصوصية، الشروط، التصدير، تفضيلات الاتصال، سجل الموافقة، حذف الحساب",
},
deleteAccount: {
  ownerHandOver: "نقل الملكية",
  ownerImpact: "أنت مالك مساحة العمل هذه ويعمل فيها آخرون. سيفقدون الوصول إليها عند حذف حسابك. للإبقاء عليها لهم، انقل الملكية إلى شخص آخر أولًا.",
  contactSupport: "تواصل مع دعم AssetWRX",
warningTitle: "سيؤدي هذا إلى حذف حسابك نهائيًا",
warningBody: "حذف حسابك إجراء لا يمكن التراجع عنه. بعد انتهاء فترة الاسترداد، لا يمكن استعادة بياناتك.",
consequencesTitle: "ما الذي سيتم حذفه",
consInspections: "جميع عمليات الفحص التي أنشأتها وتقاريرها",
consAssets: "أصولك وسجلّها",
consMedia: "الصور والمستندات والوسائط الأخرى التي رفعتها",
consTeams: "عضويات فرقك والوصول إلى مساحات العمل المشتركة",
consBilling: "يتم إلغاء الاشتراكات النشطة وإيقاف الفوترة",
recoveryBody: "تُحفظ مساحات العمل التي تملكها لمدة {{days}} يومًا ثم تُحذف نهائيًا. للسؤال عن استعادتها خلال هذه المدة، تواصل مع دعم AssetWRX. تُحذف بياناتك الشخصية فورًا.",
offlineBanner: "أنت غير متصل بالإنترنت. أعد الاتصال لحذف حسابك.",
confirmLabel: "اكتب {{token}} للتأكيد",
confirmHelper: "أدخل {{token}} تمامًا كما هو موضح لتفعيل زر الحذف.",
passwordLabel: "أكِّد كلمة المرور",
passwordHelper: "مطلوبة إذا كنت تسجّل الدخول بكلمة مرور. اتركها فارغة إذا كنت تسجّل الدخول عبر Google أو Apple أو Microsoft.",
passwordPlaceholder: "كلمة المرور",
reauthError: "يرجى إعادة إدخال كلمة المرور للتأكد من هويتك.",
genericError: "تعذّر إكمال حذف الحساب. يرجى المحاولة مرة أخرى.",
deleteButton: "حذف حسابي",
deletingStatus: "جارٍ حذف حسابك…",
modalTitle: "حذف الحساب نهائيًا؟",
modalBody: "لا يمكن التراجع عن هذا. يتم إخفاء هوية بياناتك الشخصية الآن، وتُزال مساحات العمل التي تملكها وحدك بعد فترة الاسترداد.",
modalConfirm: "حذف نهائي",
modalCancel: "الاحتفاظ بحسابي",
successTitle: "جارٍ حذف حسابك",
successBody: "تم تسجيل خروجك. بدأنا حذف بياناتك وألغينا أي اشتراكات نشطة. غيّرت رأيك؟ تواصل مع دعم AssetWRX خلال 30 يومًا.",
complianceNote: "يمكنك طلب حذف حسابك في أي وقت مباشرةً داخل التطبيق، وفقًا لمتطلبات App Store وGoogle Play.",
cancel: "إلغاء",
},
featureRequests: {
  editFirst: "تعديل أولًا",
  helpRowTitle: "طلب ميزة",
  helpRowSubtitle: "أخبرنا بما يجعل AssetWRX أفضل لك.",
  myRequestsTitle: "طلباتك",
  myRequestsSubtitle: "ما طلبته وأين وصل.",
  myRequestsRowSubtitle_zero: "لم تُرسل أي طلبات",
  myRequestsRowSubtitle_one: "طلب واحد مُرسل",
  myRequestsRowSubtitle_two: "طلبان مُرسلان",
  myRequestsRowSubtitle_few: "{{count}} طلبات مُرسلة",
  myRequestsRowSubtitle_many: "{{count}} طلبًا مُرسلًا",
  myRequestsRowSubtitle_other: "{{count}} طلب مُرسل",
  myRequestsEmpty: "لم تطلب أي ميزة بعد.",
  ideasTitle: "أفكار ندرسها",
  ideasSubtitle: "صوّت لما تريده. سنخبرك عندما تتقدم.",
  ideasRowSubtitle: "صوّت لما تريده لاحقًا.",
  ideasEmpty: "لا توجد أفكار مطروحة للتصويت حاليًا.",
  ideasFooter: "يكتب فريق AssetWRX الأفكار هنا. تبقى طلباتك الخاصة سرية.",
  loadFailed: "لم يتم التحميل. تحقق من الاتصال واسحب للأسفل للمحاولة مرة أخرى.",
  sentOn: "أُرسل في {{date}} · {{category}}",
  mergedNote: "طلب شخص آخر الشيء نفسه، لذا ضممنا طلبك إلى طلبه. سنخبرك عندما يتقدم.",
  replyFromTeam: "رد من فريق AssetWRX",
  seeWhatsNew: "عرض الجديد: {{title}}",
  onIdeasBoard: "عرضه في لوحة الأفكار",
  vote: "أريد هذا",
  voted: "تم التصويت",
  voteA11y: "التصويت لـ {{title}}",
  unvoteA11y: "سحب تصويتك لـ {{title}}",
  voteCount_zero: "لا أصوات",
  voteCount_one: "صوت واحد",
  voteCount_two: "صوتان",
  voteCount_few: "{{count}} أصوات",
  voteCount_many: "{{count}} صوتًا",
  voteCount_other: "{{count}} صوت",
  voteFailedTitle: "لم يُحفظ تصويتك",
  voteFailedBody: "تحقق من الاتصال وحاول مرة أخرى.",
  status: {
    sent: "مُرسل",
    under_review: "قيد المراجعة",
    planned: "مخطط له",
    in_progress: "قيد التطوير",
    shipped: "متاح في التطبيق الآن",
    not_planned: "غير مخطط له حاليًا",
  },
  ideaStatus: {
    considering: "قيد الدراسة",
    planned: "مخطط له",
    in_progress: "قيد التطوير",
    shipped: "متاح في التطبيق الآن",
  },
  category: {
    assets: "الأصول والأماكن",
    inspections: "الفحوصات وقوائم التحقق",
    work: "المهام والأعمال",
    schedules: "الجداول",
    reports: "التقارير",
    team: "الفريق والمقاولون",
    integrations: "التكاملات وواجهة API",
    other: "شيء آخر",
  },
  importance: {
    nice_to_have: "سيكون أمرًا جيدًا",
    saves_time: "سيوفر وقتي",
    blocking: "لا أستطيع العمل بدونه",
  },
  errors: {
    daily_limit: "أرسلت 5 طلبات اليوم. يُرجى إرسال الباقي غدًا.",
    workspace_limit: "أرسلت مساحة العمل 20 طلبًا اليوم. يُرجى المحاولة غدًا.",
    blocked: "طلبات الميزات متوقفة لحسابك. تواصل مع الدعم إذا كنت تعتقد أن هذا خطأ.",
    incomplete: "أضف عنوانًا قصيرًا واذكر ما تحتاجه.",
    screenshot: "لم تُرفع إحدى لقطات الشاشة. أزلها أو حاول مرة أخرى.",
    failed: "لم يُرسل طلبك. تحقق من الاتصال وحاول مرة أخرى.",
  },
  form: {
    title: "طلب ميزة",
    subtitle: "أخبرنا بما تحتاجه. يقرأ فريق AssetWRX كل طلب.",
    titleLabel: "ماذا تريد؟",
    titlePlaceholder: "مثال: طباعة ملصق QR لكل غرفة",
    titleRequired: "أضف عنوانًا قصيرًا.",
    descriptionLabel: "كيف سيساعدك ذلك؟",
    descriptionPlaceholder: "ما الذي تحاول فعله، وما الذي يعيقك اليوم؟",
    descriptionRequired: "اذكر باختصار ما تحتاجه.",
    categoryLabel: "أي جزء من التطبيق؟",
    categoryRequired: "اختر جزء التطبيق المعني.",
    importanceLabel: "ما مدى أهميته؟",
    screenshotsLabel: "لقطات الشاشة (اختياري)",
    screenshotsHint: "حتى 3. يُرجى عدم إظهار بيانات شخصية أو بيانات العملاء.",
    addScreenshot: "إضافة لقطة شاشة",
    addScreenshotShort: "إضافة",
    removeScreenshot: "إزالة لقطة الشاشة",
    photoPermissionTitle: "السماح بالوصول إلى الصور",
    photoPermissionBody: "لإضافة لقطة شاشة، اسمح لـ AssetWRX برؤية صورك من إعدادات الهاتف.",
    similarTitle: "طلبت شيئًا مشابهًا من قبل",
    similarHint: "إذا كان هو نفسه، يمكنك متابعته في طلباتك بدلًا من إرساله مرة أخرى.",
    detailsTitle: "يُرسل مع طلبك",
    detailsHint: "يساعدنا هذا على فهم مكانك في التطبيق. لا يُرسل أي شيء آخر من مساحة عملك.",
    detailApp: "إصدار التطبيق",
    detailUpdate: "التحديث",
    detailDevice: "الجهاز",
    detailLanguage: "اللغة",
    detailScreen: "الشاشة",
    detailWorkspace: "مساحة العمل",
    detailWorkspaceValue: "اسم مساحة عملك وخطتها",
    send: "إرسال الطلب",
    failedTitle: "لم يُرسل",
    sentTitle: "شكرًا، وصلنا طلبك",
    sentBody: "نقرأ كل طلب. ستصلك إشعار عندما تتغير حالته أو نرد عليك.",
    seeYourRequests: "عرض طلباتك",
    done: "تم",
  },
},
};
